export const extractLastDigitsFromMaskedCardNumber = (maskedCardNumber, numberOfDigits) => {
    if (!maskedCardNumber)
        return;
    const cardNumberAfterPlaceholders = maskedCardNumber.split(/\D+/g).reverse()[0];
    if (cardNumberAfterPlaceholders.length <= numberOfDigits)
        return cardNumberAfterPlaceholders;
    return cardNumberAfterPlaceholders.slice(cardNumberAfterPlaceholders.length - numberOfDigits);
};
